// import { useEffect, useState } from "react";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import ECFooter from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import PrFh from "./pages/pr_fh/index.tsx";
import PrTableconro from "./pages/pr_tableconro/index.tsx";
import Order from "./pages/order/index.tsx";
import Complete from "./pages/order/complete/index.tsx";

import ECHeader from "./components/Header";
import ErrorPayment from "./pages/error/payment";
import ErrorStock from "./pages/error/stock.tsx";
import ErrorSystem from "./pages/error/system.tsx";
import ErrorTimeout from "./pages/error/timeout.tsx";
// import ErrorTest from "./pages/error/errortest.tsx";
import NotFound from "./pages/error/notfound";
import Index from "./pages/index/index.tsx";

import "./assets/scss/global.scss";

const routes = [
    {
        path: "/",
        Component: Index,
    },
    {
        path: "/pr_fh",
        Component: PrFh,
    },
    {
        path: "/pr_tableconro",
        Component: PrTableconro,
    },
    {
        path: "/order",
        Component: Order,
    },
    {
        path: "/order/complete",
        Component: Complete,
    },
    {
        path: "/order/:product_id",
        Component: Order,
    },
    {
        path: "/error_payment",
        Component: ErrorPayment,
    },
    {
        path: "/error_stock",
        Component: ErrorStock,
    },
    {
        path: "/error_system",
        Component: ErrorSystem,
    },
    {
        path: "/error_timeout",
        Component: ErrorTimeout,
    },
    // {
    //     path: "/error_test",
    //     Component: ErrorTest,
    // },
    {
        path: "*", // 404なので最後に置く必要がある
        Component: NotFound,
    },
];

const Layout = () => {
    const location = useLocation();
    // ヘッダーを表示しないパスを定義
    const noHeaderRoutes = [
        "/pr_fh",
        "/pr_fh/",
        "/pr_tableconro",
        "/pr_tableconro/",
    ];

    // ヘッダーを非表示にするかを判定
    // noHeaderRoutesに含まれていなければヘッダーを表示（404ページも含む）
    const shouldShowHeader = !noHeaderRoutes.includes(location.pathname);

    return (
        <>
            <ScrollToTop />
            {shouldShowHeader && <ECHeader />}
            <AnimatePresence mode="wait">
                <Routes location={location} key={location.pathname}>
                    {routes.map(({ path, Component }, i) => (
                        <Route
                            key={i}
                            path={path}
                            element={
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    // exit={{ opacity: 0 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    <Component />
                                </motion.div>
                            }
                        />
                    ))}
                </Routes>
            </AnimatePresence>
            {shouldShowHeader && <ECFooter />}
        </>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Suspense fallback={<></>}>
                <Layout /> {/* Layout内でuseLocationを使用 */}
            </Suspense>
        </BrowserRouter>
    );
}
export default App;
